import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"check\"><path d=\"M4.543 9.729l-3.44-3.434-.706.707 4.274 4.269 6.772-9.48-.814-.582z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol